import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAdmin } from "../contexts/AdminContext";
import { createIndexActor } from "../lib/actors";
import type { Admin, AdminAccess } from "../lib/types";

export function AuthLoadingPage() {
  const { identity } = useAuth();
  const { setAdminAccess } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!identity) { navigate("/login"); return; }

    (async () => {
      try {
        const actor = await createIndexActor(identity);
        const result: { ok?: AdminAccess; err?: unknown } = await actor.getMyAdminAccess();
        if ("err" in result) {
          navigate("/not-authorized");
          return;
        }
        const { isInstaller, admin } = result.ok!;
        const adminRecord: Admin | null = admin.length > 0 ? (admin[0] ?? null) : null;
        setAdminAccess(isInstaller, adminRecord, actor);
        // navigation handled by AppRoutes once actor state commits
      } catch {
        navigate("/not-authorized");
      }
    })();
  }, [identity, navigate, setAdminAccess]);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 16,
    }}>
      <div style={{
        width: 36, height: 36, border: "3px solid var(--color-accent)",
        borderTopColor: "transparent", borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{ color: "var(--color-muted)", fontSize: 14 }}>Verifying access…</p>
    </div>
  );
}
